import { render, staticRenderFns } from "./product-labels.vue?vue&type=template&id=211791dd"
import script from "./product-labels.vue?vue&type=script&lang=js"
export * from "./product-labels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports